/**
 * homeUxLogger.js — Structured UX logging for Home suggestion system
 * 
 * Logs events with [HomeUX] prefix for easy filtering.
 * Each log includes simulation status, stage, variant, reason, and context.
 */

const PREFIX = '[HomeUX]';

const formatContext = (data) => {
  const { stage, variantId, reason, debug, simulationMode } = data;
  return {
    simulation: simulationMode ? 'ON' : 'OFF',
    stage: stage || '-',
    variantId: variantId || '-',
    reason: reason || '-',
    ...(debug || {}),
  };
};

const log = (type, data) => {
  const ctx = formatContext(data);
  console.log(`${PREFIX} ${type}`, ctx);
};

export const uxLog = {
  /** Logged when the engine computes a decision */
  decision: (suggestionState, simulationMode = false) => {
    log('decision', { ...suggestionState, simulationMode });
  },

  /** Logged when a suggestion becomes visible on screen */
  impression: (suggestionState, simulationMode = false) => {
    log('impression', { ...suggestionState, simulationMode });
  },

  /** Logged when user taps the suggestion CTA */
  click: (suggestionState, simulationMode = false) => {
    log('click', { ...suggestionState, simulationMode });
  },

  /** Logged when user dismisses a suggestion (if applicable) */
  dismiss: (suggestionState, simulationMode = false) => {
    log('dismiss', { ...suggestionState, simulationMode });
  },

  /** Logged when user navigates to personalization tests */
  personalizationStart: (suggestionState, simulationMode = false) => {
    log('personalization_start', { ...suggestionState, simulationMode });
  },

  /** Logged when user completes all personalization tests */
  personalizationComplete: (simulationMode = false) => {
    log('personalization_complete', { simulationMode, stage: 'COMPLETED', variantId: 'completed', reason: 'All tests done' });
  },
};

export default uxLog;
